import modalTemplate from './view.html';
import { LogsModalController } from './controller';

import { LOGS_MODAL_CONTROLLER } from '../../const';

class LogsModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (modalData = null) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: LOGS_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'nm',
            resolve: {
                modalData: modalData,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    LogsModal,
    LogsModalController,
};
